// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-About-CommandBar----index-module---root---_06bf","navigation":"src-components-About-CommandBar----index-module---navigation---312vQ","button":"src-components-About-CommandBar----index-module---button---3lPBZ","addressBar":"src-components-About-CommandBar----index-module---addressBar---ZGVRy","connect":"src-components-About-CommandBar----index-module---connect---2Dqiy","connectContainer":"src-components-About-CommandBar----index-module---connectContainer---2NtnA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/About/CommandBar/index.module.css
// module id = 447
// module chunks = 213534597649335